<template>
  <LegalSiteArticle :page="privacyPage" nav-page="privacy" />
</template>

<script>
import LegalSiteArticle from '@/components/LegalSiteArticle.vue'
import { privacyPage } from '@/data/legalPages'

export default {
  components: { LegalSiteArticle },
  data() {
    return { privacyPage }
  },
}
</script>
